import { useEffect, useState } from "react";
import MainView from "views/MainView";
import {
  thirdPartyVoiceServices,
  _H5Event,
  handleFromAppParams,
  publicPath,
  detectMobileOS,
  INTEGRATED_SERVICE,
  SERVICE_TYPE,
  IAuth,
} from "request";

import { useNavigate } from "react-router-dom";
import { RouterPath } from "routes/routerPaths";
import { FormattedMessage } from "react-intl";
import { useStoreContext } from "views/StoreContext";
import { useIntlContext } from "views/IntlContext";
import { Toast } from "antd-mobile";
import { ServiceSection } from "./components/ServiceSection";

export const ServiceList = () => {
  const navigate = useNavigate();

  const { state, dispatch } = useStoreContext();
  const { switchLanguage } = useIntlContext();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { isAndroid } = detectMobileOS();

  const onGetProductList = (data: IAuth) => {
    thirdPartyVoiceServices(data)
      .then((response: any) => {
        setIsLoading(false);
        if (response?.code === "200") {
          const integratedServices = Object.values(INTEGRATED_SERVICE);

          const services = response.result.filter((item: any) => {
            return integratedServices.includes(item.showFlag);
          });

          dispatch({ type: "SAVE_SERVICES", payload: services });
        } else {
          Toast.show({
            icon: "fail",
            content: response.message,
          });
        }
      })
      .catch((err: any) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    if (state.services.length > 0) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    const datas = {
      event: "GetTokenAndLanguage",
      pageName: "thirdApp",
      callback: (responseStr: any) => {
        const jsonData = handleFromAppParams(responseStr);
        switchLanguage?.(jsonData.lang);
        dispatch({ type: "SET_TOKEN", payload: jsonData.token });
        dispatch({ type: "SET_LANG", payload: jsonData.lang });
        onGetProductList(jsonData);
      },
    };
    _H5Event(datas);
  }, []);

  const onToCommandPage = (service: any) => {
    navigate(`/${RouterPath.serviceConnect}`, {
      state: {
        connectService: service,
        lang: state.lang,
      },
    });
  };

  const onToCompatibleDevicePage = () => {
    navigate(`/${RouterPath.compatibleDevice}`, {
      state: { token: state.token, lang: state.lang },
    });
  };

  return (
    <MainView backgroundClassName="bg-page dark:bg-black1b1f1e p-5 pt-4">
      <div
        className="bg-white dark:bg-gray323434 rounded flex items-center justify-between py-5 px-4"
        onClick={onToCompatibleDevicePage}
      >
        <img
          src={`${publicPath}/icons/ic_voice_small.png`}
          alt=""
          className="w-[18px]"
        />
        <span className="flex-1 px-4">
          <FormattedMessage id="thirdParty.service.title" />
        </span>
        <img
          src={`${publicPath}/icons/ic_more@2x.png`}
          className="w-[5px]"
          alt=""
        />
      </div>

      {Object.keys(SERVICE_TYPE).map(
        (serviceType, key) => (
            <ServiceSection
              key={key}
              serviceType={serviceType}
              services={state.services}
              isLoading={isLoading}
              onToCommandPage={onToCommandPage}
              publicPath={publicPath}
              isAndroid={isAndroid}
            />
          )
      )}
    </MainView>
  );
};
